export default __webpack_public_path__ + "static/media/searchIconDetails.a7c44fc8.svg";